import React from "react";
import FiberImage
  from "../../common/results/views/fiber/types/components/fiberimage";
import Grid from "material-ui/Grid/index";
import {withStyles} from "material-ui/styles/index";
import styles from "./BatteryStatementStyles";

class BatteryStatementEn extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {classes} = this.props;

    return <div className={classes.batteryAgreement}>
      <p className={classes.warning}>
        Important information regarding products containing lithium /
        lithium-ion
        batteries – It is forbidden to ship damaged / defective batteries
      </p>
      <p>
        <b>Check your battery!</b> Remove the battery ahead of shipping if you
        know your battery has been dropped, damaged or punctured. Or if you see
        any of the below signs of damage:
      </p>
      <ul>
        <li>Bulging</li>
        <li>Colour change</li>
        <li>Leak</li>
        <li>Unusual smell</li>
        <li>Overheating</li>
        <li>Erratic device performance</li>
      </ul>
      <p>
        Ensure that damaged batteries are disposed of in line with your local
        regulations.</p>
      <p>As the person shipping this product for any reason, including but not
        limited to return for repair, service or calibration,
        you are responsible to ensure that it is done so safely and legally. If
        you are sending your device back with the batteries
        installed, please tick to confirm that you have read the above and pack
        as appropriate.
      </p>
      <p><b>Packing for air shipment:</b></p>
      <ul>
        <li>
          The battery in your device has been tested to UN38.3
          specification It is &lt; 20Wh per cell / 100Wh per battery
          Battery weight may be between 200 – 800g dependent on
          product When contained in equipment it is:
          <ul>
            <li>UN3481</li>
            <li>proper shipping name - Lithium-ion batteries contained in
              equipment
            </li>
            <li>You need to ship in accordance of IATA DGR packing instruction
              967 section II
            </li>
          </ul>
        </li>
        <li>Leave the battery in your device</li>
        <li>Ensure that the device is switched off and cannot be accidentally
          activated
        </li>
        <li>For transport your device should not exceed a state charge of
          exceeding 30% of rated capacity<br/>
          or<br/>
          From 1st Jan 2026 your device should not exceed a state charge of
          exceeding 30% of rated capacity or with
          an indicated battery capacity not exceeding 25%
        </li>
        <li>Do not exceed more than 5kg of battery weight per package</li>
        <li>Ensure that your device is in strong rigid outer packing capable to
          withstand a 1.2m drop without damage
        </li>
        <li>The face of your package should be otherwise unmarked and the below
          should all be on one side of your
          package securely fastened and reasonably protected from damage /
          external conditions:
          <ul>
            <li>Shipper name and address</li>
            <li>Consignee name and address</li>
            <li>UN3481battery label (Label size 100mm x 100mm/ UN3481 text
              should be at least 12mm
            </li>
          </ul>
        </li>
        <li>Ensure that the device within the package is secure and does not
          move around
        </li>
        <li>You should ensure that carrier marks the AWB “Lithium-ion batteries
          in compliance with section II of PI
          967 (if carrier is booked by TREND Networks, it is TREND Networks
          responsibility)
        </li>
      </ul>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} align="center">
        <FiberImage
          alt=""
          src={'/images/battery-agreement.png'}
        />
      </Grid>
      <p>Devices containing lithium-ion batteries:</p>
      <p>SignalTEK QT, 10G CT/NT/FT/PRO, LanTEK II/III/IV/S/L, SecuriTEST IP,
        FiberMASTER QUAD/Multi mode/Single mode/Pon OTDR, FiberMASTER Fusion
        Splicer S40 & S60</p>
      <p className={classes.warning}>
        Please ensure NO restricted items are shipped with your device to TREND
        Networks. This includes, but is
        not limited to: Alcohol, Bladed items (shears, cleavers, etc.),
        Aerosols, Corrosives, Flammable liquids, etc.
      </p>
    </div>;
  }
}

export default withStyles(styles)(BatteryStatementEn);
